export type Environment = {
    contextRoot: string;
    backendUrl: string;
    eldaUrl: string;
    backendExternalUrl: string;
    eldaExternalUrl: string;
    projectVersion: string;
    gitUrl: string;
    gitCommit: string;
    gitBranch: string;
    reactAppVersion: string;
    namespace: string;
    baseUri: string;
    baseUriInternal: string;
    baseUriExternal: string;
    backendExternalUrlData: string;
    eldaExternalUrlData: string;
};

declare const _environment: Environment;
export const environment = _environment;
